import React from 'react';
import EditableName from '../EditableName';
import ShowMoreDropbox from '../ShowMoreDropbox';
import { PATHS } from '../../../constants';
import { Link } from 'react-router-dom';
import { commonService } from '../../../storeManager/common/services';
import GlobalConfig from '../../../globalConfig/globalConfig';
import HeavyRefreshButton from './HeavyRefreshButton';

const TableColumns = (props) => {
    const { BoxNameUpdateInTable, rechargeRedirect, redirectModifyPackModal, handleResume, updateHeavyRefresh } = props;

      const handleHardReset = async (row) => {
        const subscriberId = row.subscriberId;
        const payload = {
          "subscriberId": subscriberId,
          "noOfRows": 200
        };
        try {
          const response = await commonService.hardResetApi(payload);
          const responseData = response.data;
          if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
            updateHeavyRefresh(subscriberId)
            row.hardReset = false;
          }
          /*else {
            this.setState({error: responseData.message})
          }*/
        } catch(e) {
            console.log('server error', e);
          // this.setState({error: GlobalConfig.serverError})
        }
      }

    return [
        {
            key: "boxAlias",
            text: `<span>Box Friendly <br /> Name</span>`,
            formatter: (cell, row, rowIndex) => (<EditableName BoxNameUpdateInTable={BoxNameUpdateInTable} row={row} cell={cell} />)
        },
        {
            key: "subscriberId",
            text: `<span>Subscriber <br /> Id</span>`,

        },
        {
            key: "vcNumber",
            text: `<span>Digicard/CDSN</span>`,
        },
        {
            key: "boxType",
            text: `<span>Box<br />Type</span>`,
        },
        {
            key: "boxStatus",
            text: `<span>Box<br />Status</span>`,
        },
        {
            key: "connectionType",
            text: `<span>Connection<br />Type</span>`,
        },
        {
            key: "mbr",
            text: `<span>Current<br />MBR</span>`,
        },
        // {
        //     key: "accountStatus",
        //     text: `<span>Account<br />Status</span>`,
        // },
        {
            key: "",
            text: 'Action',
            formatter: (cell, row, rowIndex) => {
                return (
                    <div className="action-left-align" style={{ whiteSpace: 'nowrap' }}>
                        {row.boxStatus === 'Suspended' ? <button className='btn-secondary resume-btn' onClick={() => handleResume(row, rowIndex + 1)}>Resume</button>
                            :
                            <Link className='btn-secondary' to={{
                                pathname: PATHS.TEMPORARILY_SUSPEND,
                                state: { vcNumber: row.vcNumber, subscriberId: row.subscriberId, actionType: row.boxStatus === 'Suspended' ? "Resume" : "Suspend", noOfRows: rowIndex + 1 }
                            }}>
                                {row.boxStatus === 'Suspended' ? "Resume" : "Suspend"}
                            </Link>}
                        {/* <button className='btn-secondary' onClick={((e)=>{getSuspendDetail(item.subscriberId,index,e)})}>Suspend</button> */}
                        <button className='btn-secondary' onClick={rechargeRedirect(row.subscriberId)}>Recharge</button>
                        <button className='btn-secondary' onClick={redirectModifyPackModal(row.subscriberId, row.name)}>Modify</button>
                        {row.connectionType === 'Primary' && 
                            <HeavyRefreshButton row={row} handleHardReset={handleHardReset}/>
                        }
                    </div>
                )

            }
        },
        {
            key: "",
            text: 'More',
            formatter: (cell, row, rowIndex) => {
                return (
                    <ShowMoreDropbox row={row} heavyRefresh={updateHeavyRefresh} />
                )

            }
        }

        //  {
        //      key: "balance",
        //      text: "Balance"
        //  }
    ]
}
export default TableColumns;
